import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ActivityFindInterface } from '@zaoblako/shared/modules/finance/dtos/activity/activity-find.dto';
import type { ActivityPageInterface } from '@zaoblako/shared/modules/finance/dtos/activity/activity-page.dto';
import type { ActivityQueryInterface } from '@zaoblako/shared/modules/finance/dtos/activity/activity-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TypeOfActivityService extends BaseService {
  protected baseUrl = '/fdo/activity';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public restoreOne(id: number): Observable<ActivityPageInterface> {
    return this.http.post<ActivityPageInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public findWithPagination(queryParams: ActivityQueryInterface): Observable<ActivityPageInterface> {
    return this.http.get<ActivityPageInterface>(`${this.baseUrl}/items`, { params: this.objectToHttpParams(queryParams) });
  }

  /**
   * @deprecated Use {@link TypeOfActivityService.findWithPagination} method instead
   */
  public findAll(): Observable<ActivityFindInterface[]> {
    return this
      .findWithPagination({
        limit: 500,
        select: ['id', 'name']
      })
      .pipe(map(({ items }) => items));
  }
}
